import React, { useState, useEffect, useContext } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { Switch, Spin, Button, Card } from 'antd';
import { link } from '../../dynamic/api';


import Select from 'react-select';

import { DataContext } from '../../init/getData';

function AppMode() {

  const { api, userData, refData, devData, companyId } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role.name;

  const [isLoading, setIsLoading] = useState(true);
  const [devSettingData, setDevSettingData] = useState(null);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['devData']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    setDevSettingData(devData);
  }, [devData]);




  const handleSubmit = async (e) => {
    e.preventDefault();


    const settings = devSettingData;


    const res = await api.post(`/dev/edit`, JSON.stringify({ settings }))
    if (res.data.status) {
      toast.success(res.data.message);
    }
    else {
      toast.error(res.data.message);
    }

  }



  const handleChange = (name, value) => {

    setDevSettingData((prev) => ({
      ...prev,
      [name]: value,
    }));


  }

  const handleChangeMode = (name, value) => {
    setDevSettingData((prev) => ({
      ...prev,
      isServer: name === "isServer" ? value : false,
      isOffline: name === "isOffline" ? value : false,
      isClient: name === "isClient" ? value : false,
    }));
  };


  return (
    <Card >


      <Spin size="large" spinning={isLoading} style={{ margin: 'auto' }} />


      {!isLoading && devSettingData &&

        <Form onSubmit={handleSubmit} style={{ width: '45%', margin: '0', marginTop: '30px' }} id='settingForm'>


          {/* is Web App */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3} className="align-self-center">Web App</Form.Label>
            <Col>
              <Switch style={{ backgroundColor: devSettingData.isWebApp ? '#23576a' : '#bebfbe' }}
                checked={devSettingData.isWebApp}
                onChange={(e) => handleChange('isWebApp', e)} />
            </Col>
          </Form.Group>


          {/* is Server */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3} className="align-self-center">is Server</Form.Label>
            <Col>
              <Switch style={{ backgroundColor: devSettingData.isServer ? '#23576a' : '#bebfbe' }}
                checked={devSettingData.isServer}
                onChange={(e) => handleChangeMode('isServer', e)} />
            </Col>
          </Form.Group>



          {/* is offline */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3} className="align-self-center">is Offline</Form.Label>
            <Col>
              <Switch style={{ backgroundColor: devSettingData.isOffline ? '#23576a' : '#bebfbe' }}
                checked={devSettingData.isOffline}
                onChange={(e) => handleChangeMode('isOffline', e)} />
            </Col>
          </Form.Group>

          {/* is Client */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3} className="align-self-center">is Client</Form.Label>
            <Col>
              <Switch style={{ backgroundColor: devSettingData.isClient ? '#23576a' : '#bebfbe' }}
                checked={devSettingData.isClient}
                onChange={(e) => handleChangeMode('isClient', e)} />
            </Col>
          </Form.Group>


          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3}>Server Link</Form.Label>
            <Col sm={9}>
              <Form.Control type="text" step='any' placeholder="http.. " style={{ width: '70%' }}
                value={devSettingData?.serverLink}
                onChange={(e) => setDevSettingData({ ...devSettingData, serverLink: e.target.value })}
              />
            </Col>
          </Form.Group>


          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3}>My Local Link</Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={link} step='any' placeholder="http://example.com:5001 " style={{ width: '70%' }} readOnly />
            </Col>
          </Form.Group>


          <Form.Group as={Row} className="mb-3">
            <Col sm={{ span: 10, offset: 2 }}>
              <Button style={{ backgroundColor: '#23576a', color: 'white' }} onClick={handleSubmit}>Save</Button>
            </Col>
          </Form.Group>



        </Form>

      }

    </Card >
  );
}

export default AppMode;
